import { TypeMask } from "../common/interfaces";

export const insertMask = (value: string, mask: TypeMask) => {
  value = value.replace(/\D/g, "");

  switch (mask) {
    case "cpf":
      if (value.length <= 11) {
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d)/, "$1.$2");
        value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
      }

      return value;
    case "cnpj":
      if (value.length <= 14) {
        value = value.replace(/^(\d{2})(\d)/, "$1.$2");
        value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
        value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
        value = value.replace(/(\d{4})(\d)/, "$1-$2");
      }

      return value;
    case "dob":
      if (value.length <= 6) {
        value = value.replace(/(\d{2})(\d{2})(\d{4})/g, "$1/$2/$3");
      }
      return value;
    default:
      return value;
  }
};
